import React, { useMemo } from 'react';
import DeleteIcon from 'src/components/10-atoms/icons/DeleteIcon';
import NoteItem from 'src/modules/exam-preparation/containers/Notes/NoteItem';
import useI18n from 'src/modules/translations/hooks/useI18n';
const SubjectNoteItem = ({ onRemove, ...noteItemProps }) => {
    const { translate } = useI18n();
    const menuOptions = useMemo(() => [{
            Icon: DeleteIcon,
            title: translate('Remove'),
            onPress: () => onRemove(),
        }], [onRemove, translate]);
    return (React.createElement(NoteItem, { ...noteItemProps, menuOptions: menuOptions }));
};
export default SubjectNoteItem;
